import { useState } from "react";
import "./App.css";

import VideoDownloader from "./VideoDownloader/VideoDownloader";
import { AppProvider } from './AppContext/AppContext';

function App() {
  return (
    <AppProvider>
      <VideoDownloader />
    </AppProvider>
  );
}

export default App;
